<template>
  <a-row :gutter="24">
    <a-col :span="12">
      <a-form-model-item label="起始价" prop="startingPrice">
        <a-input
          v-model="startingPrice"
          disabled
          :suffix="form.floorPriceeUnit === 1 ? '元/月' : '元/年'"
        />
      </a-form-model-item>
    </a-col>

    <a-col :span="12">
      <a-form-model-item label="加价幅度" prop="minimumIncrement">
        <a-input
        placeholder="请输入加价幅度"
          v-model="form.minimumIncrement"
          :suffix="form.floorPriceeUnit === 1 ? '元/月' : '元/年'"
        />
      </a-form-model-item>
    </a-col>

    <a-col :span="12">
      <a-form-model-item label="最高加价倍数" prop="maximumIncrement">
        <a-input placeholder="请输入最高加价倍数" v-model="form.maximumIncrement" />
      </a-form-model-item>
    </a-col>

    <a-col :span="12">
      <a-form-model-item label="是否允许以起始价报价" prop="allowStartingQuote">
        <a-radio-group v-model="form.allowStartingQuote">
          <a-radio :value="1">是</a-radio>
          <a-radio :value="0">否</a-radio>
        </a-radio-group>
      </a-form-model-item>
    </a-col>

    <a-col :span="24">
      <a-row :gutter="24">
        <a-col :span="12">
          <a-form-model-item label="定时报价时长" prop="timedQuoteDuration">
            <a-form-model-item
              prop="timedQuoteDuration"
              :style="{
                display: 'inline-block',
                width: 'calc(100% - 150px)',
              }"
            >
              <a-input-number
                :min="1"
                :precision="0"
                style="width: 100%;"
                v-model="form.timedQuoteDuration"
                placeholder="请输入定时报价时长"
              />
            </a-form-model-item>
            <span
              :style="{
                display: 'inline-block',
                width: '20px',
                textAlign: 'center',
              }"
            >
            </span>
            <a-form-model-item
              prop="timedQuoteDurationUnit"
              :style="{
                display: 'inline-block',
                width: '130px',
              }"
            >
              <a-select
                v-model="form.timedQuoteDurationUnit"
                placeholder="请选择"
              >
                <a-select-option :value="1">小时</a-select-option>
                <a-select-option :value="2">分钟</a-select-option>
                <a-select-option :value="3">秒</a-select-option>
                <a-select-option :value="4">天</a-select-option>
              </a-select>
            </a-form-model-item>
          </a-form-model-item>
        </a-col>

        <a-col :span="12">
          <a-form-model-item label="连续报价周期" prop="continuousQuoteDuration">
            <a-form-model-item
              prop="continuousQuoteDuration"
              :style="{
                display: 'inline-block',
                width: 'calc(100% - 150px)',
              }"
            >
              <a-input-number
                :min="1"
                :precision="0"
                style="width: 100%;" v-model="form.continuousQuoteDuration" placeholder="请输入连续报价周期" />
            </a-form-model-item>
            <span
              :style="{
                display: 'inline-block',
                width: '20px',
                textAlign: 'center',
              }"
            >
            </span>
            <a-form-model-item
              prop="continuousQuoteDurationUnit"
              :style="{
                display: 'inline-block',
                width: '130px',
              }"
            >
              <a-select v-model="form.continuousQuoteDurationUnit" placeholder="请选择">
                <a-select-option :value="1">小时</a-select-option>
                <a-select-option :value="2">分钟</a-select-option>
                <a-select-option :value="3">秒</a-select-option>
                <a-select-option :value="4">天</a-select-option>
              </a-select>
            </a-form-model-item>
          </a-form-model-item>
        </a-col>
      </a-row>
    </a-col>
  </a-row>
</template>

<script>
export default {
  props: {
    form: {
      type: Object,
      default: () => null,
    },
    startingPrice: {
      type: Number,
      default: () => null,
    },
  },
};
</script>

<style>
</style>